/* eslint-disable react-hooks/exhaustive-deps */
import { Grid } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { AppTable, DeleteConfirmDialog } from "components/molecules";
import { TableHelper } from "helpers";
import { usePaginationRequest } from "hooks/useRequest";
import {
  IDownloadExcelRequest,
  IPaginateApiResponse,
  IPaginationRequest,
  IWarehouse,
} from "model";
import { IZone } from "model/Zone/IZone";
import { Fragment, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { DownloadActions, WarehouseActions } from "redux/actions";
import { useAppSelector } from "redux/configurations/reduxHooks";
import { WarehouseApiService } from "services";
import { CURRENT_PAGE_SIZE, EXPORT_FILE_NAME, FIRST_PAGE } from "utils/Const";
import { I18nTranslator, translations } from "utils/i18n";

const WarehouseConfiguration = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const action = useAppSelector((state) => state.WarehouseReducer.action);
  const downloading = useAppSelector(
    (state) => state.AppConfigReducer.downloading
  );

  const [open, setOpen] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const [itemSelected, setItemSelected] = useState<IZone>();
  const [request, setRequest] = useState<IPaginationRequest>({
    pageNumber: FIRST_PAGE,
    pageSize: CURRENT_PAGE_SIZE,
  });

  const onClickEditWarehouse = (item: any) => {
    delete item["no"];
    history.push(`${location.pathname}/edit/${item.id}`, {
      item: JSON.stringify(item),
    });
  };

  const handleClickAddNew = () => {
    history.push(`${location.pathname}/new`);
  };

  const onClickDeleteWarehouse = (item: any) => {
    setItemSelected(item);
    setOpen(true);
  };

  const handleCloseDeleteWarehouse = () => {
    setOpen(false);
  };

  const handleDeleteWarehouse = () => {
    _deleteWarehouse(itemSelected?.id!);
  };

  const deleteWarehouseSuccessfully = action.includes(
    WarehouseActions.deleteWarehouse.successName
  );

  const _downloadWarehouseMasterData = () => {
    const params: IDownloadExcelRequest = {
      ...request,
      pageSize: (result as IPaginateApiResponse<IWarehouse[]>).totalRecords,
      pageNumber: FIRST_PAGE,
      fileName: EXPORT_FILE_NAME.warehouseMasterData,
    };
    dispatch(DownloadActions.downloadWarehouseMasterData.request(params));
  };

  const { loading, result } = usePaginationRequest<
    IPaginationRequest,
    IWarehouse[]
  >(
    request,
    WarehouseApiService.getAllWarehouses,
    [],
    { refresh: refresh },
    () => {
      setRefresh(false);
    }
  );

  const _deleteWarehouse = (id: string) => {
    dispatch(
      WarehouseActions.deleteWarehouse.request({
        id: id,
      })
    );
  };
  const _clearAction = () => {
    dispatch(WarehouseActions.clearAction.request());
  };
  const _handlePageChange = (pageNumber: number) => {
    setRequest({ ...request, pageNumber: pageNumber });
  };
  const _handleSearchTextChange = (searchText: string) => {
    setRequest({ ...request, pageNumber: FIRST_PAGE, searchText: searchText });
  };
  const _handlePageSizeChange = (pageSize: number) => {
    setRequest({ ...request, pageSize: pageSize });
  };

  useEffect(() => {
    if (deleteWarehouseSuccessfully) {
      setRefresh(true);
      setOpen(false);
      _clearAction();
    }
  }, [action]);

  const COLUMNS: GridColDef[] = [
    TableHelper.renderSTT(),
    TableHelper.createCell({
      field: "warehouseCode",
      headerName: I18nTranslator(translations.masterData.warehouseCode),
      size: "small",
      align: "left",
      sortable: true,
    }),
    TableHelper.createCell({
      field: "description",
      headerName: I18nTranslator(translations.masterData.warehouseName),
      size: "full",
      align: "left",
      sortable: true,
    }),

    TableHelper.renderActivationCell(),
  ];
  return (
    <Fragment>
      <AppTable<IWarehouse>
        title={I18nTranslator(translations.masterData.warehouseConfiguration)}
        loading={loading}
        data={result}
        columns={COLUMNS}
        onAddNewClick={handleClickAddNew}
        onSearch={_handleSearchTextChange}
        searchPlaceholder={I18nTranslator(translations.placeholder.warehouse)}
        onChangePage={_handlePageChange}
        onRowPressEdit={onClickEditWarehouse}
        onRowPressDelete={onClickDeleteWarehouse}
        onDownloadClick={_downloadWarehouseMasterData}
        isDownloading={downloading}
        actionColumnProps={{ hideImport: true }}
        onPageSizeChange={_handlePageSizeChange}
        hideImport
      />
      <DeleteConfirmDialog
        open={open}
        value={itemSelected?.description}
        handleClose={handleCloseDeleteWarehouse}
        handleDelete={handleDeleteWarehouse}
        isDeleting={action.includes(
          WarehouseActions.deleteWarehouse.requestName
        )}
      />
    </Fragment>
  );
};

export default WarehouseConfiguration;
